/* ─────────────────────────────────────────────────────────────────────────────
   ОДИН СПИСОК ПРИЛОЖЕНИЙ на весь ноутбук: из него собираются и док, и рабочий
   стол, и заголовок окна. Раньше список жил внутри домашнего экрана, из-за чего
   док приходилось собирать второй раз.
   ───────────────────────────────────────────────────────────────────────────── */
import { derived } from 'svelte/store';
import { charData, charFractionID, charFractionLVL, charOrganizationID, charIsLeader, charIsCrime } from 'store/chars';
import fraction from 'json/fraction.js';
import { executeClient } from 'api/rage';
import { currentPage } from './stores';

/* «Заказы гос.» — отдел закупок мэрии: приложение видят только сотрудники
   Cityhall начиная с 10 ранга. Другие гос-структуры получают груз, но
   оформляет поставку правительство, поэтому список фракций здесь один. */
const GOS_ORDERS_FRACTIONS = [6];   // 6 — Cityhall (см. json/fraction.js)
const GOS_ORDERS_RANK = 10;

export const appsList = derived(
    [charData, charFractionID, charFractionLVL, charOrganizationID, charIsLeader, charIsCrime],
    ([char, fracId, fracLvl, orgId, isLeader, isCrime]) => {
        const list = [];

        if (fracId > 0) list.push({
            id: 'Fractions', icon: 'shield', tone: 'gold',
            name: fraction[fracId] || 'Фракция',
            meta: isLeader ? 'Вы лидер' : 'Ваша фракция',
        });

        /* ⚠️ Ранг — ТОЛЬКО число из стора charFractionLVL, который заполняет
           сервер (postavki.cs → cef.gos.access, см. src_client/ipad/gos.js).
           В charData.FractionLVL лежит НАЗВАНИЕ ранга («Мэр»), и сравнение
           строки с числом молча давало false — приложение не появлялось. */
        const fracRank = Number(fracLvl) || 0;
        const myFraction = Number(fracId) || (char && Number(char.FractionID)) || 0;

        if (GOS_ORDERS_FRACTIONS.includes(myFraction) && fracRank >= GOS_ORDERS_RANK) list.push({
            id: 'gos', icon: 'gos', tone: 'gold',
            name: 'Заказы гос.', meta: 'Снабжение города',
        });

        /* «Война за хаммеры» — мероприятие криминала. Видно любому сотруднику
           банды, мафии или байкеров с первого ранга: событие общее, ограничивать
           его по должности смысла нет. */
        if (Number(isCrime)) list.push({
            id: 'vzh', icon: 'war', tone: 'red',
            name: 'Война за хаммеры', meta: 'Мероприятие криминала',
        });

        if (orgId > 0) list.push({
            id: 'Organization', icon: 'org', tone: 'violet',
            name: 'Организация', meta: 'Дела и состав',
        });
        else list.push({
            id: 'orgcreate', icon: 'orgcreate', tone: 'violet',
            name: 'Создать организацию', meta: 'Собрать своих',
        });

        if (char && char.houseId) list.push({
            id: 'home', icon: 'home', tone: 'blue', page: true,
            name: 'Мой дом', meta: 'Дом №' + char.houseId,
        });

        if (char && char.BizId) list.push({
            id: 'biz', icon: 'biz', tone: 'green', page: true,
            name: 'Мой бизнес', meta: 'Бизнес №' + char.BizId,
        });

        list.push({ id: 'trucker', icon: 'trucker', tone: 'orange', name: 'Дальнобойщик', meta: 'Заказы и рейсы' });
        list.push({ id: 'marketPlace', icon: 'market', tone: 'pink', name: 'Маркетплейс', meta: 'Купить и продать', external: true });

        return list;
    }
);

/** открыть приложение: маркетплейс живёт в отдельном окне игры, остальные — здесь */
export const runApp = (app, onSelectedView) => {
    if (!app) return;

    if (app.external && app.id === 'marketPlace') {
        executeClient('client.ipad.close');
        executeClient('client.marketPlace.openApp');
        return;
    }

    if (app.page) currentPage.set(app.id);
    onSelectedView (app.id);
}
